import { render, staticRenderFns } from "./AvatarWithDnD.vue?vue&type=template&id=12d6dc8c&scoped=true&"
import script from "./AvatarWithDnD.vue?vue&type=script&lang=ts&"
export * from "./AvatarWithDnD.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarWithDnD.vue?vue&type=style&index=0&id=12d6dc8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d6dc8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VImg,VRow})
